module.exports = __webpack_public_path__ + "img/4B-Traps2.197963fc.png";